module.exports = __webpack_public_path__ + "img/coins.b1c7f263.svg";